import LargeModuleScss from '../styles/large.module.scss';
import MediumModuleScss from '../styles/medium.module.scss';
import SmallModuleScss from '../styles/small.module.scss';
import { MutableRefObject, useEffect, useRef } from 'react';

export const useSize = (): typeof LargeModuleScss|typeof MediumModuleScss|typeof SmallModuleScss => {
    if (process.env.REACT_APP_SIZE === 'l') {
        return LargeModuleScss;
    } else if (process.env.REACT_APP_SIZE === 'm') {
        return MediumModuleScss;
    }
    return SmallModuleScss;
};